import { SezUsError } from '.'

export class ErroneousResponseError extends SezUsError {
  static get friendly() {
    return 'This property can only be read.';
  }

  static set friendly(value) {
    throw new Error(`The friendly property cannot be written. ${value} was passed.`);
  }

  constructor(internal = 'Http request failure', friendly) {
    super({ internal, friendly })
    this.friendly = friendly

    Object.setPrototypeOf(this, ErroneousResponseError.prototype)
  }

  serialize() {
    return this.messages
  }
}
